import React from "react";
import "./Preloader.css"; // estilos opcionales

const Preloader = () => (
  <div className="preloader-overlay">
    <div className="spinner" />
    <p>Cargando...</p>
  </div>
);

export default Preloader;